/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useRef, forwardRef} from 'react'
import {useRefObjectAsForwardedRef} from '../..'

import {
  Button as AriaButton,
  ComboBox as AriaComboBox,
  Input as AriaInput,
  Item as AriaItem,
  Label as AriaLabel,
  ListBox as AriaListBox,
  Popover as AriaPopover,
  Section as AriaSection,
  Header as AriaHeader,
  Collection as AriaCollection,
  Text as AriaText
} from 'react-aria-components'
import {
  CollectionProps as AriaCollectionProps,
  ComboboxRootProps,
  ComboboxInputProps,
  ComboboxLabelProps,
  ComboboxButtonProps,
  ComboboxItemProps,
  ComboboxPopoverProps,
  ComboboxListBoxProps,
  ComboboxSectionProps,
  ComboboxHeaderProps,
  ComboboxTextProps
} from './types'

// Combobox Root
// --------------------------------------------------------
// export interface ComboboxRootProps<T extends object>
//   extends Omit<
//       AriaComboBoxProps<T>,
//       | "children"
//       | "placeholder"
//       | "name"
//       | "label"
//       | "description"
//       | "errorMessage"
//     >,
//     AriaRenderProps<ComboBoxState<T>>,
//     AriaSlotProps {
//   /** The filter function used to determine if a option should be included in the combo box list. */
//   defaultFilter?: (textValue: string, inputValue: string) => boolean;
//   /** */
//   label?: string;
//   /** */
//   description?: string | null;
//   /** */
//   errorMessage?: string | null;
//   /** */
//   children?: React.ReactNode;
//   /** */
//   UNSAFE_className?: string;
// }

/** */
// const Root = forwardRef(
//   (
//     {
//       children,
//       UNSAFE_className,
//       ...props
//     }: ComboboxRootProps<{
//       label?: string;
//       description?: string | null;
//       errorMessage?: string | null;
//       children?: React.ReactNode;
//       UNSAFE_className?: string;
//     }>,
//     forwardedRef
//   ) => {
//     const innerRef = useRef<HTMLDivElement>(null);
//     useRefObjectAsForwardedRef(forwardedRef, innerRef);

//     return (
//       <AriaComboBox ref={innerRef} className={UNSAFE_className} {...props}>
//         {children}
//       </AriaComboBox>
//     );
//   }
// );

// @TODO: forwardRef
const Root = <T extends object>({label, description, errorMessage, children, ...props}: ComboboxRootProps<T>) => {
  const innerRef = useRef<HTMLDivElement>(null)
  // useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return (
    <AriaComboBox ref={innerRef} {...props}>
      {children}
    </AriaComboBox>
  )
}

const Label = ({children, UNSAFE_className, ...props}: ComboboxLabelProps) => {
  return (
    <AriaLabel className={UNSAFE_className} {...props}>
      {children}
    </AriaLabel>
  )
}

const Input = forwardRef(({children, UNSAFE_className, ...props}: ComboboxInputProps, forwardedRef) => {
  const innerRef = useRef<HTMLInputElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)
  return (
    <AriaInput ref={innerRef} className={UNSAFE_className} {...props}>
      {children}
    </AriaInput>
  )
})

const Button = ({children, UNSAFE_className, ...props}: ComboboxButtonProps) => {
  return (
    <AriaButton className={UNSAFE_className} {...props}>
      {children}
    </AriaButton>
  )
}

const Item = forwardRef(({children, UNSAFE_className, ...props}: ComboboxItemProps, forwardedRef) => {
  const innerRef = useRef<HTMLElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)
  return (
    <AriaItem ref={innerRef} className={UNSAFE_className} {...props}>
      {children}
    </AriaItem>
  )
})

const Popover = forwardRef(({children, UNSAFE_className, ...props}: ComboboxPopoverProps, forwardedRef) => {
  const innerRef = useRef<HTMLElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)

  return (
    <AriaPopover ref={innerRef} className={UNSAFE_className} {...props}>
      {children}
    </AriaPopover>
  )
})

const Listbox = forwardRef(({children, UNSAFE_className, ...props}: ComboboxListBoxProps<{}>, forwardedRef) => {
  const innerRef = useRef<HTMLDivElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)
  return (
    <AriaListBox ref={innerRef} className={UNSAFE_className} {...props}>
      {children}
    </AriaListBox>
  )
})

const Section = <T extends object>({children, UNSAFE_className, ...props}: ComboboxSectionProps<T>) => {
  const innerRef = useRef<HTMLDivElement>(null)
  // useRefObjectAsForwardedRef(forwardedRef, innerRef)
  return (
    <AriaSection {...props} className={UNSAFE_className}>
      {children}
    </AriaSection>
  )
}

const Header = forwardRef(({children, ...props}: ComboboxHeaderProps, forwardedRef): JSX.Element => {
  const innerRef = useRef<HTMLElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)

  return (
    <AriaHeader ref={innerRef} {...props}>
      {children}
    </AriaHeader>
  )
})

const Collection = <T extends object>({children, ...props}: AriaCollectionProps<T>) => {
  // useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return <AriaCollection {...props}>{children}</AriaCollection>
}

const Text = forwardRef(({children, ...props}: ComboboxTextProps, forwardedRef) => {
  const innerRef = useRef<HTMLElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, innerRef)

  return (
    <AriaText ref={innerRef} {...props}>
      {children}
    </AriaText>
  )
})
// --------------------------------------------------------
// Exports
Root.displayName = 'Combobox'
Label.displayName = 'Label'
Input.displayName = 'Input'
Button.displayName = 'Button'
Item.displayName = 'Item'
Popover.displayName = 'Popover'
Listbox.displayName = 'Listbox'
Section.displayName = 'Section'
Header.displayName = 'Header'
Collection.displayName = 'Collection'
Text.displayName = 'Text'

export default Object.assign(Root, {
  Label,
  Input,
  Button,
  Item,
  Popover,
  Listbox,
  Section,
  Header,
  Collection,
  Text
})
